<template>
  <StockTrendList />
</template>

<script>
import StockTrendList from '@/components/screening/StockTrendList.vue'

export default {
  name: 'StockTrendListView',
  components: {
    StockTrendList
  }
}
</script>
